<template>
  <div>
    <el-row :gutter="20">
      <el-col :md="8" :lg="5">
        <el-input placeholder="订单号" v-model="params.order_id" clearable><el-button slot="append" icon="el-icon-search" @click="searchData"></el-button></el-input>
      </el-col>
      <el-col :md="8" :lg="5">
        <el-input placeholder="邀请店铺英克id" v-model="params.promoter_yk_number" clearable><el-button slot="append" icon="el-icon-search" @click="searchData"></el-button></el-input>
      </el-col>
      <el-col :md="8" :lg="5">
        <el-input placeholder="邀请人手机号" v-model="params.promoter_mobile" clearable><el-button slot="append" icon="el-icon-search" @click="searchData"></el-button></el-input>
      </el-col>
      <el-col :md="8" :lg="5">
        <el-input placeholder="会员手机" v-model="params.mobile" clearable><el-button slot="append" icon="el-icon-search" @click="searchData"></el-button></el-input>
      </el-col>

      <el-col :md="9" :lg="9">
        <el-date-picker v-model="date_time" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"  @change="dateChange" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd" size="mini">
        </el-date-picker>
      </el-col>

      <el-button type="primary" icon="plus" @click="exportData">
        导出当前数据
      </el-button>
      <el-button type="primary" icon="plus" @click="exportDatacw">
        导出当前财务数据
      </el-button>

    </el-row>
    <el-table :data="vipGradeList" :height="wheight-80" v-loading="loading">
      <el-table-column prop="order_id" label="订单号" width="170"></el-table-column>
      <el-table-column prop="lv_type" label="会员卡等级" width="100"></el-table-column>
      <el-table-column prop="title" label="会员卡名称"></el-table-column>
      <el-table-column prop="card_type" label="会员卡类型" width="100">
        <template slot-scope="scope">
          {{scope.row.card_type.desc}}
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="会员手机号"></el-table-column>
      <el-table-column prop="price" label="购买金额" width="100">
        <template slot-scope="scope">
          ￥{{scope.row.price/100}}
        </template>
      </el-table-column>
      <el-table-column prop="distributor_number" label="推送门店id"></el-table-column>
      <el-table-column prop="distributor_name" label="推送门店名称"></el-table-column>
      <!--<el-table-column prop="discount" label="折扣值" width="100">-->
        <!--<template slot-scope="scope">{{(100-scope.row.discount)/100}}折</template>-->
      <!--</el-table-column>-->
      <el-table-column prop="promoter_mobile" label="邀请人"></el-table-column>
      <el-table-column prop="promoter_yk_number" label="邀请店铺英克id"></el-table-column>
      <el-table-column prop="created" label="下单时间" width="">
        <template slot-scope="scope">
          <span>{{scope.row.created | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="push_np_status" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.push_np_status == '0'">没有推送</span>
          <span v-else-if="scope.row.push_np_status == '1'">推送成功</span>
          <span v-else-if="scope.row.push_np_status == '2'">推送失败</span>
          </br>
          <span v-if="scope.row.order_status == 'CANCEL'">已取消</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="">
        <template slot-scope="scope">
          <el-button type="text" v-show="scope.row.push_np_status !== '1' && scope.row.order_status =='DONE' " @click="pushVipToNp(scope.$index, scope.row)">推送np</el-button>
          <el-button type="text" v-show="scope.row.order_status == 'DONE'" @click="refundVipOrderp(scope.$index, scope.row)">退费</el-button>
        </template>
      </el-table-column>


    </el-table>
    <div class="content-padded content-center">
      <el-pagination background
                     layout="prev, pager, next, total"
                     @current-change="handleCurrentChange"
                     :current-page.sync="params.page"
                     :total="total_count" :page-size="params.pageSize">
      </el-pagination>
    </div>


  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  import { listVipGrade,exportVipGrade,sendVipOrderToNp,refundVipOrder} from '../../../api/member'
  export default {
    data () {
      return {
        isEdit: false,
        vipGradeList: [],
        loading: false,
        total_count: 0,
        date_time:'',
        params: {
          promoter_yk_number:'',
          promoter_mobile:'',
          start:'',
          end:'',
          page: 1,
          pageSize: 20,
        },
        form: {
          tag_id: '',
          tag_name: '',
          tag_color: '#ff1939',
          font_color: '#ffffff',
          description: ''
        },
        memberTagDialog: false,
        predefineColors:['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate () { // 添加商品
        this.memberTagDialog = true
        this.form = {tag_id: '',tag_name: '',tag_color: '#ff1939',description: ''  }
      },
      editAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      preview (index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      dateChange(val){
          if (!val) {
              this.params.start = ''
              this.params.end = ''
              return false
          }
          this.params.start = val[0]
          this.params.end = val[1]
          this.getDataList()
      },
      getDataList () {
        this.loading = true
        listVipGrade(this.params).then(response => {
          this.vipGradeList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      pushVipToNp(index, row){

          sendVipOrderToNp({order_id:row.order_id}).then(response => {
              if (response.data.data) {
                  this.$message({
                      type: 'success',
                      message: '推送成功'
                  })
                  this.getDataList()
              }
          })
      },
      refundVipOrderp(index,row){
            console.log(index)
            console.log(row.order_id)
          this.$confirm('是否确认退费将会员状态恢复,费用需要联系订单中心退款, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              refundVipOrder({order_id:row.order_id}).then(response => {
                  console.log(response.data.data,'xxxxx')
                  if (response.data.data) {
                      this.$message({
                          type: 'success',
                          duration: 10 * 1000,
                          message: '取消成功,退款交易号' + response.data.data.trade_id + '请提交给订单中心退款'
                      })
                      this.getDataList()
                  }
              })
          }).catch(() => {
              this.params.action = ''
              this.$message({
                  type: 'info',
                  message: '已取消'
              })
          })

      },
      deleteAction (index, row) {
        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteTag(row.tag_id).then(response => {
            this.vipGradeList.splice(index, 1)
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      exportData(){
            exportVipGrade(this.params).then(response => {
                //console.log(response.data)
                if(response.data) {
                    var a = document.createElement('a')
                    a.href = response.data.url
                    a.download = response.data.filename
                    a.click()
                }
            })
        },
      exportDatacw(){
          this.params.cw_flag = 1;
          exportVipGrade(this.params).then(response => {
              //console.log(response.data)
              if(response.data) {
                  var a = document.createElement('a')
                  a.href = response.data.url
                  a.download = response.data.filename
                  a.click()
              }
          })
      },
      getTaskTime (strDate) {
          let date = new Date(strDate)
          let y = date.getFullYear()
          let m = date.getMonth() + 1
          m = m < 10 ? ('0' + m) : m
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let str = y+"-"+m+"-"+d
          return str
      },
      getTimeStr (date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog () {
  			this.memberTagDialog = false
      },
      saveTagData () {
        this.memberTagDialog = false
        if (this.form.tag_id) {
          updateTag(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        } else {
          saveTag(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        }
      }
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// list.vue?382d20aa